import './Status.css'
import { Text } from '../units/Text'
import { FlexWrapper } from '../Wrappers/Wrappers'

export const SuccessStatus = () => {
    return (
        <FlexWrapper alignItems='center' justifyContent='center' className='status-wrapper bg-success'>
            <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 1L6.70711 11.2929C6.31658 11.6834 5.68342 11.6834 5.29289 11.2929L1 7" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </FlexWrapper>
    )
}